import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { faCalendarAlt } from '@fortawesome/pro-light-svg-icons';
import { AppSettings } from 'src/app/app-settings';

@Component({
  selector: 'app-events-horizontal-card',
  templateUrl: './events-horizontal-card.component.html',
  styleUrls: ['./events-horizontal-card.component.scss']
})
export class EventsHorizontalCardComponent {
  @Input() event: any;
  eventImgURL: string = "";
  idEvent: string | null = null;
  public faCalendar = faCalendarAlt;

  constructor(private route: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {
    this.idEvent = this.route.snapshot.paramMap.get('idEvent');
    if (this.event) {
      this.eventImgURL = AppSettings.API_EVENTS_ASSETS + this.event.image_url;
    }
  }
  changeEvent() {
    const reservationId = this.route.snapshot.queryParamMap.get('reservationId');
    if (reservationId) {
      this.router.navigate(['event-sale/' + this.event.id], { queryParams: { reservationId } });
    } else {
      this.router.navigate(['event-sale/' + this.event.id]);
    }
  }

}